import * as React from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import { auth } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { findUserByEmail, saveUser, sendMailWithMailJet, saveSubscription } from "../services/api";
import MyToast from './MyToast';
import MySpinner from './MySpinner';
import './SignUp.css'
const all_countries = require('../json/countries.json');

export default function SignUp() {
    const navigate = useNavigate();

    const [registerData, setRegisterData] = React.useState({ country: 'Cameroon' });
    const [inProgress, setinProgress] = React.useState(false);
    const [countries, setCountries] = React.useState([]);
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [openToast, setOpenToast] = React.useState({
        open: false,
        msg: '',
        severity: ''
    });

    React.useEffect(() => {
        // Utilisation du fichier JSON local au lieu de l'API
        setCountries(all_countries);
    }, []);

    const handleChange = e => {
        setRegisterData({ ...registerData, [e.target.name]: e.target.value });
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        //vérifions les paramètres requis
        let { name, firstName, email, country, password, cfpassword } = registerData;
        if (!name || !email || !country || !password || !cfpassword) {
            setOpenToast({
                open: true,
                msg: "Veuillez renseigner tous les champs !",
                severity: "error"
            })
            return;
        }

        if (password.length < 6) {
            setOpenToast({
                open: true,
                msg: "Le mot de passe doit voir au moins 6 caractères",
                severity: "error"
            })
            return;
        }

        if (password !== cfpassword) {
            setOpenToast({
                open: true,
                msg: "Les mots de passe ne correspondent pas",
                severity: "error"
            })
            return;
        }

        try {
            setinProgress(true);

            const exists = await findUserByEmail(email);
            if (!exists || exists.status !== 200) {
                setOpenToast({
                    open: true,
                    msg: "Une erreur s'est produite, veuillez réessayer ultérieurement",
                    severity: "error"
                })
                setinProgress(false);
                return;
            }

            if (exists && exists.data?.data) {
                setOpenToast({
                    open: true,
                    msg: "Cette adresse email est déjà utilisée",
                    severity: "error"
                })
                setinProgress(false);
                return;
            }

            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            const userData = {
                userID: user.uid,
                name,
                email,
                country,
                firstName
            }

            const rep = await saveUser(userData);

            setOpenToast({
                open: true,
                msg: "Inscription réussie",
                severity: "success"
            })

            setinProgress(false);
            navigate('/accueil');

            /* const subscription = await saveSubscription({
                offerID: '6514e39fa3d34a00087a10bb',
                userID: user.uid,
                startDate: new Date().toISOString(),
                endDate: new Date(new Date().getTime() + 5 * 24 * 60 * 60 * 1000).toISOString(),
                couponID: '6526bb7a6df040c1814deb33',
                subscriptionStatus: 'ACTIVED'
            }); */

            sendMailWithMailJet({
                from: 'services@exams-tcfcanada.com',
                to_email: email,
                from_name: 'EXAMS-TCF-CANADA',
                subject: `Confirmation d'inscription à EXAMS-TCFCANADA`,
                text: `
Cher(e) ${name},\n
Nous sommes ravis de vous accueillir sur notre plateforme ! Vous avez réussi avec succès à vous inscrire, et nous sommes très heureux de vous compter parmi nos utilisateurs.
Nous tenons à vous remercier de nous avoir choisi pour vous préparer à l'exament du TCF CANADA. 
Si vous avez des questions, des préoccupations ou si vous avez besoin d'une assistance quelconque, n'hésitez pas à nous contacter à l'adresse examstcfcanada@gmail.com ou via https://www.exams-tcfcanada.com/contactez-nous.
Cordialement,\n
Service client
EXAMS-TCFCANADA.COM
https://exams-tcfcanada.com
services@exams-tcfcanada.com
examstcfcanada@gmail.com
                `
            });

            sendMailWithMailJet({
                from: 'services@exams-tcfcanada.com',
                to_email: `examstcfcanada@gmail.com`,
                from_name: 'Inscription',
                subject: 'Nouvelle inscription',
                text: `Nouvelle inscription avec l'adresse email suivante: \n\n ${email}`
            });

        } catch (error) {
            setinProgress(false);
            const errorCode = error?.code;
            const errorMessage = error?.message;

            if (errorCode == 'auth/email-already-in-use') {
                setOpenToast({
                    open: true,
                    msg: "Cette adresse email est déjà utilisée",
                    severity: "error"
                })
                return;
            }
            else if (errorCode === 'auth/network-request-failed') {
                setOpenToast({
                    open: true,
                    msg: "Vérifiez votre connexion internet",
                    severity: "error"
                })
            }
            else {
                setOpenToast({
                    open: true,
                    msg: "Une erreur s'est produite, veuillez réessayer ultérieurement",
                    severity: "error"
                })
            }
        }
    };

    return (
        <div className="su-container">
            <div className="su-signup-wrapper">
                <div className="su-card">
                    <div className="su-card-header">
                        <div className="su-title-container">
                            <h1 className="su-title">Inscription</h1>
                        </div>
                        <div className="su-login-link-container">
                            <p className="su-login-text">
                                Vous avez déjà un compte?
                                <NavLink className="su-login-link" to="/connexion">
                                    Connexion
                                </NavLink>
                            </p>
                        </div>
                    </div>

                    <div className="su-card-body">
                        <form onSubmit={handleSubmit} className="su-form">
                            <div className="su-form-group">
                                <label className="su-label" htmlFor="name">Votre nom</label>
                                <div className="su-input-container">
                                    <span className="su-input-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="12" cy="7" r="4"></circle>
                                        </svg>
                                    </span>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="su-input"
                                        placeholder="Votre nom"
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="su-form-group">
                                <label className="su-label" htmlFor="firstName">Votre prénom</label>
                                <div className="su-input-container">
                                    <span className="su-input-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="12" cy="7" r="4"></circle>
                                        </svg>
                                    </span>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        className="su-input"
                                        placeholder="Votre prénom"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="su-form-group">
                                <label className="su-label" htmlFor="email">Votre adresse e-mail</label>
                                <div className="su-input-container">
                                    <span className="su-input-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6Z" />
                                            <path d="M22 6L12 13L2 6" />
                                        </svg>
                                    </span>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="su-input"
                                        placeholder="exemple@email.com"
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="su-form-group">
                                <label className="su-label" htmlFor="country">Votre pays</label>
                                <div className="su-select-container">
                                    <span className="su-input-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <line x1="2" y1="12" x2="22" y2="12"></line>
                                            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                        </svg>
                                    </span>
                                    <select
                                        id="country"
                                        name="country"
                                        className="su-select"
                                        value={registerData.country}
                                        onChange={handleChange}
                                        required
                                    >
                                        {countries.map((country, index) => (
                                            <option key={index} value={country.value}>
                                                {country.label}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="su-select-arrow">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="6 9 12 15 18 9"></polyline>
                                        </svg>
                                    </span>
                                </div>
                            </div>

                            <div className="su-form-row">
                                <div className="su-form-group su-form-group-half">
                                    <label className="su-label" htmlFor="password">Mot de passe</label>
                                    <div className="su-input-container">
                                        <span className="su-input-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                            </svg>
                                        </span>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            name="password"
                                            className="su-input"
                                            placeholder="••••••••"
                                            onChange={handleChange}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="su-password-toggle"
                                            onClick={togglePasswordVisibility}
                                        >
                                            {showPassword ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                    <line x1="2" y1="2" x2="22" y2="22" />
                                                </svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                    <small className="su-password-hint">Minimum 6 caractères</small>
                                </div>

                                <div className="su-form-group su-form-group-half">
                                    <label className="su-label" htmlFor="cfpassword">Confirmer le mot de passe</label>
                                    <div className="su-input-container">
                                        <span className="su-input-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                            </svg>
                                        </span>
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            id="cfpassword"
                                            name="cfpassword"
                                            className="su-input"
                                            placeholder="••••••••"
                                            onChange={handleChange}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="su-password-toggle"
                                            onClick={toggleConfirmPasswordVisibility}
                                        >
                                            {showConfirmPassword ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                    <line x1="2" y1="2" x2="22" y2="22" />
                                                </svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="su-form-group">
                                <div className="su-terms-privacy">
                                    <p className="su-terms-text">
                                        En vous inscrivant, vous acceptez nos
                                        <a href="/conditions-utilisation" className="su-terms-link">Conditions d'utilisation</a>
                                        et notre
                                        <a href="/politique-confidentialite" className="su-terms-link">Politique de confidentialité</a>
                                    </p>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="su-button-primary"
                                disabled={inProgress}
                            >
                                {inProgress ? (
                                    <span className="su-spinner-small"></span>
                                ) : "M'inscrire"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <MyToast
                openToast={openToast}
                setOpenToast={setOpenToast}
            />

            {inProgress && <MySpinner loading={inProgress} />}
        </div>
    );
}